<template>
  <router-link :to="`/cards/${product.category}/${product.slug}`" class="group block">
    <div class="bg-white rounded-2xl shadow-sm hover:shadow-lg transition-shadow overflow-hidden">
      <div class="aspect-square bg-gray-100 flex items-center justify-center">
        <img v-if="product.image" :src="product.image" :alt="product.name" class="w-full h-full object-cover" />
        <div v-else class="text-4xl">{{ product.emoji || '🎁' }}</div>
      </div>
      <div class="p-4">
        <h3 class="font-semibold text-gray-900 group-hover:text-blue-600">{{ product.name }}</h3>
        <p class="text-sm text-gray-500 mt-1">À partir de {{ product.minPrice }} XOF</p>
      </div>
    </div>
  </router-link>
</template>

<script setup>
defineProps({
  product: {
    type: Object,
    required: true
  }
});
</script>
